import axios from 'axios';

const api = '/api/bonus-deductions';

export const getBonusDeductions = params => {
  return axios.get(`${api}/${params}?cacheBuster=${new Date().getTime()}`);
};

export const getBonusDeductionById = id => {
  return axios.get(`${api}/${id}?cacheBuster=${new Date().getTime()}`);
};

export const getAgentLight = id => {
  return axios.get(`${api}/light/${id}?cacheBuster=${new Date().getTime()}`);
};

export const createBonus = data => {
  return axios.post(`${api}?cacheBuster=${new Date().getTime()}`, data);
};

export const updateBonus = (id, data) => {
  return axios.put(`${api}/${id}?cacheBuster=${new Date().getTime()}`, data);
};
